import { useSyncExternalStore } from 'react'

/** Subscribes to a CSS media query. False where `matchMedia` does not exist (tests, old browsers): wide layout. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => {}
      const list = window.matchMedia(query)
      list.addEventListener('change', notify)
      return () => list.removeEventListener('change', notify)
    },
    () => (typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false),
    () => false,
  )
}

/** The phone layout: the primary navigation moves to the bottom bar at 760px and below (PAGES.md 3.1). */
export const PHONE_QUERY = '(max-width: 760px)'
/** The search field collapses to an icon button at 1100px and below. */
export const COMPACT_QUERY = '(max-width: 1100px)'
